module.exports = __webpack_public_path__ + "static/media/99.fd0b213e.jpg";